import React from 'react';
import { CollapseSection, FieldSet } from '@alfa-retail-react/components';

const getClientRequirements = () => [
    { value: 'Возраст от 21 до 65 лет.', className: 'advantagesListItem' },
    {
        value: 'Стаж не менее 3 месяцев на текущем месте работы в РБ.',
        className: 'advantagesListItem',
    },
    {
        value: 'Документ, удостоверяющий личность, со сроком действия не менее 35 дней: паспорт или ID-карта гражданина РБ, ВНЖ или биометрический ВНЖ иностранца или лица без гражданства в РБ.',
        className: 'advantagesListItem',
    },
    {
        value: 'Оформить карту могут в том числе ИП, работники ИП и самозанятые.',
        className: 'advantagesListItem',
    },
];

export const ProductRequirements = () => {
    const requirements = getClientRequirements();

    return (
        <CollapseSection
            className="IntroProductRequirements"
            header="Требования к клиенту"
        >
            <FieldSet className="advantagesList" fieldsProps={requirements} />
        </CollapseSection>
    );
};
